import DataApi from './DataApi';

class CurrencyApi extends DataApi {
  constructor() {
    super('currency');
  }
}

export default CurrencyApi;
